module.exports = __webpack_public_path__ + "img/kefu_jjj.c4930a5f.png";